import React, { useCallback, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import "./login.css";
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import PhoneInput from 'react-phone-number-input';
import { getCountryCallingCode } from 'libphonenumber-js';
import RegistrationLogout from '../../components/common/RegistrationLogout';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Select from 'react-select';
import { toast } from 'react-toastify';

function RegisterDetail4() {
    const navigate = useNavigate();

    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = {
        US: 10,
        IN: 10,
        CA: 10,
        DE: 11,
        AU: 9,
        GB: 10,
        PK: 10,
    };

    // ─── State ────────────────────────────────────────────────────────────────
    const [submitLoader, setSubmitLoader] = useState(false);
    const [submitloader, setSubmitloader] = useState(false);
    const [show, setShow] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [referrers, setReferrers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [generalData, setgeneraldata] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [refetchedData, setRefetchedData] = useState({});
    const [profiles, setProfile] = useState([]);
    const [relationships, setRelationships] = useState([]);
    const [citizenshipStatuses, setCitizenshipStatuses] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    const [value, setValue] = useState(null);
    const [value1, setValue1] = useState(null);
    const [value2, setValue2] = useState(null);
    const [value3, setValue3] = useState(null);

    const [opendata, setOpendata] = useState(false);
    const [opendata2, setOpendata2] = useState(false);
    const [opendata3, setOpendata3] = useState(false);
    const [opendata4, setOpendata4] = useState(false);
    const [opendataUsc, setOpendataUsc] = useState(false);

    const [maxDate, setMaxDate] = useState('');

    const [errors, setErrors] = useState({});

    const [fileNames, setFileNames] = useState({
        passport_document: '',
        i94_copy: '',
        proof_of_work_authorization: '',
        profile: '',
    });

    const [formData, setFormData] = useState({
        request_type: 'correct_my_profile',
        details: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        dob: '',
        gender: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        why_enroll: '',
        password: '',
        confirm_password: '',
        citizenship_status: '',
        awaiting_ead_card: '',
        ead_card_applied_date: '',
        citizenship_explanation: '',
        legally_authorized_to_work: '',
        ssn_issue_year: '',
        work_authorization_expiry: '',
        renew_authorization_work: '',
        laws_and_regulations: false,
        i94_copy: null,
        passport_document: null,
        proof_of_work_authorization: null,
        profile: null,
        first_name1: '',
        last_name1: '',
        phone_number1: '',
        relation_type: '',
        referrer_name: '',
        referral_phone_number: '',
        referrer_relationship: '',
    });
    const [reSaveData, setResaveData] = useState({
        referrer_name: '',
        referral_phone_number: '',
        referrer_relationship: '',
    })

    // ─── Effects ──────────────────────────────────────────────────────────────

    useEffect(() => {
        const today = dayjs();
        setMaxDate(today.format('YYYY-MM-DD'));
    }, []);

    // Citizenship / work-auth expiry side-effect
    useEffect(() => {
        if (formData.work_authorization_expiry) {
            const newValue = dayjs(formData.work_authorization_expiry, 'YYYY-MM-DD');
            if (newValue.isValid()) {
                const sixMonthsFromNow = dayjs().add(6, 'month');
                if (newValue.isBefore(sixMonthsFromNow)) {
                    setOpendata4(true);
                } else {
                    setOpendata4(false);
                    setFormData((prev) => ({ ...prev, renew_authorization_work: '' }));
                }
            }
        } else {
            setOpendata4(false);
        }
    }, [formData.work_authorization_expiry]);

    // Block browser back while modal is open
    useEffect(() => {
        const handlePopState = () => {
            if (show) {
                window.history.pushState(null, null, window.location.href);
            }
        };
        if (show) {
            window.history.pushState(null, null, window.location.href);
            window.addEventListener('popstate', handlePopState);
        }
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [show]);

    // General settings
    useEffect(() => {
        const fetchsetsData = async () => {
            try {
                const response = await apiService.getRequest('/general-settings');
                if (response.success === true) {
                    setgeneraldata(response.data);
                }
            } catch (error) {
                console.error('Error fetching general settings:', error);
            }
        };
        fetchsetsData();
    }, []);

    // Referrers / relationships / citizenship statuses / states
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.postRequest('generalsettings-data');
                if (response.success) {
                    setReferrers(response.referrers || []);
                    setRelationships(response.relationships || []);
                    setCitizenshipStatuses(response.citizenship_statuses || []);
                    setStates(response.states || []);
                }
            } catch (error) {
                console.error('Error fetching referrers:', error);
            }
        };
        fetchData();
    }, []);

    // Fetch cities when state changes
    useEffect(() => {
        if (!formData.state) return;
        const fetchCities = async () => {
            try {
                const response = await apiService.postRequest(`cities/${formData.state}`);
                if (response.success) {
                    setCities(response.data || []);
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        };
        fetchCities();
    }, [formData.state]);

    // ─── Citizenship validation helper ────────────────────────────────────────

    const handleCitizenshipValidation = useCallback((data) => {
        const citizenshipStatus = data.citizenship_status;

        const isUscOrGc = citizenshipStatus === 'USC' || citizenshipStatus === 'GC';
        setOpendataUsc(isUscOrGc);

        const isEad =
            citizenshipStatus === 'OPT EAD' ||
            citizenshipStatus === 'GC EAD' ||
            citizenshipStatus === 'H4 EAD';
        setOpendata(isEad);

        if (!isEad) {
            setOpendata2(false);
        } else {
            setOpendata2(data.awaiting_ead_card === 'yes');
        }

        const authorizedNonPermanent =
            data.legally_authorized_to_work === 'yes' &&
            citizenshipStatus !== 'USC' &&
            citizenshipStatus !== 'GC';
        setOpendata3(authorizedNonPermanent);

        if (data.legally_authorized_to_work === 'no') {
            setOpendata4(true);
        } else if (!authorizedNonPermanent) {
            const workAuthExpiry = dayjs(data.work_authorization_expiry);
            if (workAuthExpiry.isValid()) {
                setOpendata4(workAuthExpiry.isBefore(dayjs().add(6, 'month')));
            } else {
                setOpendata4(false);
            }
        }
    }, []);

    // ─── User history fetch ───────────────────────────────────────────────────

    const fetchUserHistory = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.postRequest('auth/user/history');
            if (response && response.success) {
                setProfile(response.data);

                const refData = response.data;
                const immigrationData = refData.immigration_data || {};
                const emergencyconData = refData.emergency_contact || {};
                const referrerData = refData.referral_info || {};

                setRefetchedData(refData);

                const updatedFormData = {
                    request_type: 'correct_my_profile',
                    details: '',
                    password: '',
                    confirm_password: '',
                    first_name: refData.first_name || '',
                    last_name: refData.last_name || '',
                    phone_number: refData.phone_number || '',
                    email: refData.email || '',
                    dob: refData.dob || '',
                    gender: refData.gender || '',
                    address: refData.address || '',
                    city: refData.city || '',
                    state: refData.state || '',
                    zipcode: refData.zipcode || '',
                    why_enroll: refData.why_enroll || '',

                    citizenship_status: immigrationData.citizenship_status || '',
                    awaiting_ead_card: immigrationData.awaiting_ead_card || '',
                    ead_card_applied_date: immigrationData.ead_card_applied_date || '',
                    citizenship_explanation: immigrationData.citizenship_explanation || '',
                    legally_authorized_to_work: immigrationData.legally_authorized_to_work || '',
                    ssn_issue_year: immigrationData.ssn_issue_year || '',
                    work_authorization_expiry: immigrationData.work_authorization_expiry || '',
                    renew_authorization_work: immigrationData.renew_authorization_work || '',
                    laws_and_regulations: true,
                    passport_document: immigrationData.passport_document || null,
                    i94_copy: immigrationData.i94_copy || null,
                    proof_of_work_authorization: immigrationData.proof_of_work_authorization || null,
                    profile: refData.profile || null,

                    first_name1: emergencyconData.first_name || '',
                    last_name1: emergencyconData.last_name || '',
                    phone_number1: emergencyconData.phone_number || '',
                    relation_type: emergencyconData.relation_type || '',

                    referrer_name: referrerData.referrer_name || '',
                    referral_phone_number: referrerData.referral_phone_number || '',
                    referrer_relationship: referrerData.referrer_relationship || '',
                };
                setFormData2({
                    referrer_name: referrerData.referrer_name || '',
                    referral_phone_number: referrerData.referral_phone_number || '',
                    referrer_relationship: referrerData.referrer_relationship || '',
                })
                setResaveData({
                    referrer_name: referrerData.referrer_name || '',
                    referral_phone_number: referrerData.referral_phone_number || '',
                    referrer_relationship: referrerData.referrer_relationship || '',
                })
                setFormData(updatedFormData);
                
                // State / city selects
                setSelectedState(
                    refData.state
                        ? { label: refData.state_name || '', value: refData.state }
                        : null
                );
                setSelectedCity(
                    refData.city ? { label: refData.city, value: refData.city } : null
                );

                // File name display
                setFileNames({
                    passport_document: immigrationData.passport_document
                        ? immigrationData.passport_document.split('/').pop()
                        : '',
                    i94_copy: immigrationData.i94_copy
                        ? immigrationData.i94_copy.split('/').pop()
                        : '',
                    proof_of_work_authorization: immigrationData.proof_of_work_authorization
                        ? immigrationData.proof_of_work_authorization.split('/').pop()
                        : '',
                    profile: refData.profile ? refData.profile.split('/').pop() : '',
                });

                // Date pickers
                if (refData.dob) {
                    const parsed = dayjs(refData.dob, 'YYYY-MM-DD');
                    if (parsed.isValid()) setValue(parsed);
                }
                if (immigrationData.ead_card_applied_date) {
                    const parsed = dayjs(immigrationData.ead_card_applied_date, 'YYYY-MM-DD');
                    if (parsed.isValid()) setValue2(parsed);
                }
                if (immigrationData.work_authorization_expiry) {
                    const parsed = dayjs(immigrationData.work_authorization_expiry, 'YYYY-MM-DD');
                    if (parsed.isValid()) setValue1(parsed);
                }
                if (immigrationData.ssn_issue_year) {
                    setValue3(dayjs().year(Number(immigrationData.ssn_issue_year)));
                }

                handleCitizenshipValidation(updatedFormData);
            } else if (response && response.authenticate === false) {
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        } catch (error) {
            console.error('fetchUserHistory error:', error);
        } finally {
            setLoading(false);
        }
    }, [handleCitizenshipValidation]);

    useEffect(() => {
        fetchUserHistory();
    }, [fetchUserHistory]);

    // ─── Modal handlers ───────────────────────────────────────────────────────

    const handleClose = () => {
        setShow(false);
        navigate('*');
    };

    const handleClosePreview = () => {
        setShowPreview(false);
    };

    // ─── Phone helpers ────────────────────────────────────────────────────────

    /** Generic phone change factory */
    const makePhoneChangeHandler = (fieldName, isFormData2 = false) => (value) => {
        const setter = isFormData2
            ? (val) => setFormData2((prev) => ({ ...prev, [fieldName]: val }))
            : (val) => setFormData((prev) => ({ ...prev, [fieldName]: val }));

        if (value) {
            const country = allowedCountries.find((c) =>
                value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';
            const maxLength = maxPhoneLengths[country];
            const phoneWithoutCode = value
                .replace(`+${getCountryCallingCode(country)}`, '')
                .replace(/\D/g, '');
            if (phoneWithoutCode.length <= maxLength) {
                setter(value);
            }
        } else {
            setter('');
        }
    };

    /** Generic keydown guard factory */
    const makePhoneKeyDownHandler = (getPhoneValue) => (event) => {
        const { key } = event;
        if (!/\d/.test(key)) return;
        const currentValue = getPhoneValue();
        const country = allowedCountries.find((c) =>
            currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';
        const maxLength = maxPhoneLengths[country];
        const phoneWithoutCode = currentValue
            .replace(`+${getCountryCallingCode(country)}`, '')
            .replace(/\D/g, '');
        if (phoneWithoutCode.length >= maxLength) {
            event.preventDefault();
        }
    };

    // Step-4 referral phone (formData2 – kept for the outer referral card only)
    const [formData2, setFormData2] = useState({
        referrer_name: '',
        referral_phone_number: '',
        referrer_relationship: '',
    });
    const [errors2, setErrors2] = useState({});
    const [errorMessage2, setErrorMessage2] = useState('');

    const handlePhoneChangeStep4 = makePhoneChangeHandler('referral_phone_number', true);
    const handleKeyDownStep4 = makePhoneKeyDownHandler(
        () => formData2.referral_phone_number || ''
    );

    // Main form referral phone (inside preview modal)
    const handlePhoneChange = makePhoneChangeHandler('referral_phone_number', false);
    const handleKeyDown2 = makePhoneKeyDownHandler(
        () => formData.referral_phone_number || ''
    );

    // ─── Phone number formatter (US-style) ───────────────────────────────────

    const formatUSPhone = (raw) => {
        const digits = raw.replace(/\D/g, '');
        if (digits.length <= 3) return `(${digits}`;
        if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    };

    const makeUSPhoneHandler = (fieldName) => (e) => {
        const inputElement = e.target;
        const formatted = formatUSPhone(inputElement.value);
        setFormData((prev) => ({ ...prev, [fieldName]: formatted }));
        setErrors((prev) => {
            const next = { ...prev };
            if (!formatted) {
                next[fieldName] = 'Phone number is required';
            } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formatted)) {
                next[fieldName] = 'Phone number must be in the format: (123) 456-7890';
            } else {
                delete next[fieldName];
            }
            return next;
        });
    };

    const handlePhoneNumberChange = makeUSPhoneHandler('phone_number');
    const handlePhoneNumberChange1 = makeUSPhoneHandler('phone_number1');

    // ─── Generic input change ─────────────────────────────────────────────────

    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setFormData2((prev) => ({ ...prev, [name]: value }));
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const booleanIntFields = [
            'is_employee', 'is_cad', 'is_csa', 'is_csi',
            'is_auto_farwards', 'is_reset', 're_onboarding',
        ];

        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]:
                    type === 'radio' || type === 'checkbox'
                        ? booleanIntFields.includes(name)
                            ? checked ? 1 : 0
                            : checked
                        : value,
            };

            // Side-effects on citizenship_status
            if (name === 'citizenship_status') {
                const isUscOrGc = value === 'USC' || value === 'GC';
                setOpendataUsc(isUscOrGc);
                const isEad = value === 'OPT EAD' || value === 'GC EAD' || value === 'H4 EAD';
                setOpendata(isEad);
                if (!isEad) {
                    setOpendata2(false);
                    updated.awaiting_ead_card = '';
                    updated.ead_card_applied_date = '';
                }
            }

            // Side-effects on awaiting_ead_card
            if (name === 'awaiting_ead_card') {
                if (value === 'yes') {
                    setOpendata2(true);
                } else {
                    setOpendata2(false);
                    updated.ead_card_applied_date = '';
                }
            }

            return updated;
        });

        // Clear the matching error
        setErrors((prev) => {
            const next = { ...prev };
            delete next[name];
            return next;
        });
    };

    // ─── Date change handlers ─────────────────────────────────────────────────

    const handleDateChange = (newValue) => {
        setValue(newValue || null);
        setFormData((prev) => ({ ...prev, dob: newValue ? newValue.format('YYYY-MM-DD') : '' }));
        if (newValue) setErrors((prev) => { const n = { ...prev }; delete n.dob; return n; });
    };


    const handleDateChange1 = (newValue) => {
        setValue2(newValue || null);
        setFormData((prev) => ({ ...prev, ead_card_applied_date: newValue ? newValue.format('YYYY-MM-DD') : '' }));
        if (newValue) setErrors((prev) => { const n = { ...prev }; delete n.ead_card_applied_date; return n; });
    };

    const handleDateChange2 = (newValue) => {
        setValue1(newValue || null);
        setFormData((prev) => ({ ...prev, work_authorization_expiry: newValue ? newValue.format('YYYY-MM-DD') : '' }));
        if (!newValue) setOpendata4(false);
        if (newValue) setErrors((prev) => { const n = { ...prev }; delete n.work_authorization_expiry; return n; });
    };

    const handleDateChange3 = (newValue) => {
        setValue3(newValue || null);
        setFormData((prev) => ({ ...prev, ssn_issue_year: newValue ? newValue.format('YYYY') : '' }));
        if (newValue) setErrors((prev) => { const n = { ...prev }; delete n.ssn_issue_year; return n; });
    };

    // ─── State / City selects ─────────────────────────────────────────────────

    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        setSelectedCity(null);
        setFormData((prev) => ({
            ...prev,
            state: selectedOption ? selectedOption.value : '',
            city: '',
        }));
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
        setFormData((prev) => ({
            ...prev,
            city: selectedOption ? selectedOption.value : '',
        }));
    };

    // ─── File change ──────────────────────────────────────────────────────────

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            const file = files[0];
            setFormData((prev) => ({ ...prev, [name]: file }));
            setFileNames((prev) => ({ ...prev, [name]: file.name }));
        }
    };

    // ─── Validation: Step-4 standalone card ──────────────────────────────────

    const validateStep4 = () => {
        const errs = {};
        if (!formData2.referrer_name.trim()) {
            errs.referrer_name = 'Referrer name is required';
        } else if (formData2.referrer_name.length < 3) {
            errs.referrer_name = 'Referrer name must be at least 3 characters long';
        } else if (formData2.referrer_name.length > 200) {
            errs.referrer_name = 'Referrer name must be less than 200 characters long.';
        }
        if (!formData2.referral_phone_number) {
            errs.referral_phone_number = 'Phone number is required';
        }
        if (!formData2.referrer_relationship) {
            errs.referrer_relationship = 'Referrer relationship is required';
        }
        return errs;
    };

    // ─── Validation: Full preview form ───────────────────────────────────────

    const validate2 = () => {
        const errs = {};

        if (!formData.first_name) errs.first_name = 'First name is required';
        if (!formData.last_name) errs.last_name = 'Last name is required';
        if (!formData.phone_number.trim()) {
            errs.phone_number = 'Phone number is required';
        } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone_number)) {
            errs.phone_number = 'Phone number must be in the format: (123) 456-7890';
        }
        if (!formData.dob) errs.dob = 'Date of Birth is required';
        if (!formData.state) errs.state = 'State is required';
        if (!formData.city) errs.city = 'City is required';
        if (!formData.gender) errs.gender = 'Gender is required';
        if (!formData.address.trim()) errs.address = 'Address is required';
        if (!formData.zipcode.trim()) {
            errs.zipcode = 'Zipcode is required';
        } else {
            const len = formData.zipcode.length;
            if (len < 5) errs.zipcode = 'Zipcode must be at least 5 characters long';
            else if (len > 5 && len < 9) errs.zipcode = 'Zipcode must be either 5 or at least 9 characters long';
        }
        if (formData.password !== '') {
            const pwdRx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
            if (!pwdRx.test(formData.password)) {
                errs.password =
                    'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and any one special character.';
            }
            if (formData.password !== formData.confirm_password) {
                errs.confirm_password = 'Passwords do not match!';
            }
        }

        if (!formData.citizenship_status) errs.citizenship_status = 'Citizenship status is required';
        if (opendata && !formData.awaiting_ead_card) errs.awaiting_ead_card = 'Please select if you are awaiting your EAD Card';
        if (opendata2 && !formData.ead_card_applied_date) errs.ead_card_applied_date = 'EAD card application date is required';
        if (!formData.citizenship_explanation) errs.citizenship_explanation = 'Please explain your citizenship status';
        if (!formData.legally_authorized_to_work) errs.legally_authorized_to_work = 'Please select if you are legally authorized to work';
        if (!formData.ssn_issue_year) errs.ssn_issue_year = 'SSN issue year is required';
        if (opendata3 && !formData.work_authorization_expiry) errs.work_authorization_expiry = 'Work authorization expiry date is required';
        if (opendata4 && !formData.renew_authorization_work) errs.renew_authorization_work = 'Work authorization renewal action details is required';

        if (opendataUsc) {
            if (!formData.passport_document && typeof formData.passport_document !== 'string') {
                errs.passport_document = 'Passport Copy is required';
            }
        } else {
            if (!formData.laws_and_regulations) errs.laws_and_regulations = 'Please confirm the authorization to verify I-94';
            if (!formData.i94_copy && typeof formData.i94_copy !== 'string') errs.i94_copy = 'I-94 Copy is required';
        }
        if (!opendata2 && !formData.proof_of_work_authorization && typeof formData.proof_of_work_authorization !== 'string') {
            errs.proof_of_work_authorization = 'Proof of work authorization is required';
        }

        if (!formData.first_name1.trim()) errs.first_name1 = 'First name is required';
        if (!formData.last_name1.trim()) errs.last_name1 = 'Last name is required';
        if (!formData.phone_number1.trim()) {
            errs.phone_number1 = 'Phone number is required';
        } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone_number1)) {
            errs.phone_number1 = 'Phone number must be in the format: (123) 456-7890';
        }
        if (!formData.relation_type) errs.relation_type = 'Relationship is required';

        if (!formData.referrer_name.trim()) errs.referrer_name = 'Referrer name is required';
        if (!formData.referral_phone_number) errs.referral_phone_number = 'Phone number is required';
        if (!formData.referrer_relationship) errs.referrer_relationship = 'Referrer relationship is required';

        return errs;
    };
    // ─── Submit step-4 to API (confirm button) ────────────────────────────────
    const [submitloader2, setSubmitloader2] = useState(false)
    const handleSubmitStep4 = async (e) => {
        e.preventDefault();
        const validationErrors = validateStep4();
        if (Object.keys(validationErrors).length > 0) {
            setErrors2(validationErrors);
            return;
        }
        setSubmitloader2(true);
        try {
            const response = await apiService.postRequest('auth/register/step4', formData2);
            if (response && response.success) {
                setErrors2({});
                fetchUserHistory();
                setErrorMessage2('');
                setShowPreview(true);
            } else {
                setShowPreview(false);
                setErrorMessage2(response.message || 'Failed. Please try again');
                if (response.errors) setErrors2(response.errors);
                if (response && response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('handleSubmitStep4 error:', error);
        } finally {
            setSubmitloader2(false);
        }
    };

    const handleSubmitConfirm = async (e) => {
        setSubmitLoader(true);
        try {
            const params = {
                "registration_completed": true
            }
            const response = await apiService.postRequest('/auth/user/complete-registration', params);
            if (response && response.success) {
                setErrors2({});
                fetchUserHistory();
                setErrorMessage2('');
                setShowPreview(false);
                setShow(true);
            } else {
                toast(response.message || 'Failed. Please try again');
                if (response && response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('handleSubmitStep4 error:', error);
        } finally {
            setSubmitLoader(false);
        }
    }
    // ─── Submit full profile update ───────────────────────────────────────────

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setErrorMessage('');
        setSubmitloader(true);
        try {
            const validationErrors = validate2();
            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                setErrorMessage('Please fix the errors before proceeding.');
                return;
            }

            const fd = new FormData();

            const appendIfChanged = (key, current, original, formKey) => {
                if (current !== original) fd.append(formKey || key, current);
            };

            appendIfChanged('first_name', formData.first_name, refetchedData.first_name);
            appendIfChanged('last_name', formData.last_name, refetchedData.last_name);
            appendIfChanged('phone_number', formData.phone_number, refetchedData.phone_number);
            appendIfChanged('dob', formData.dob, refetchedData.dob);
            appendIfChanged('gender', formData.gender, refetchedData.gender);
            appendIfChanged('address', formData.address, refetchedData.address);
            appendIfChanged('city', formData.city, refetchedData.city);
            appendIfChanged('state', formData.state, refetchedData.state);
            appendIfChanged('zipcode', formData.zipcode, refetchedData.zipcode);
            if (formData.password !== '') {
                fd.append('password', formData.password);
                fd.append('confirm_password', formData.confirm_password);
            }
            if (formData.profile !== refetchedData.profile) fd.append('profile', formData.profile);

            const imm = refetchedData.immigration_data || {};
            appendIfChanged('citizenship_status', formData.citizenship_status, imm.citizenship_status);
            appendIfChanged('awaiting_ead_card', formData.awaiting_ead_card, imm.awaiting_ead_card);
            appendIfChanged('ead_card_applied_date', formData.ead_card_applied_date, imm.ead_card_applied_date);
            appendIfChanged('citizenship_explanation', formData.citizenship_explanation, imm.citizenship_explanation);
            appendIfChanged('legally_authorized_to_work', formData.legally_authorized_to_work, imm.legally_authorized_to_work);
            appendIfChanged('ssn_issue_year', formData.ssn_issue_year, imm.ssn_issue_year);
            appendIfChanged('work_authorization_expiry', formData.work_authorization_expiry, imm.work_authorization_expiry);
            appendIfChanged('renew_authorization_work', formData.renew_authorization_work, imm.renew_authorization_work);
            if (formData.i94_copy !== imm.i94_copy) fd.append('i94_copy', formData.i94_copy);
            if (formData.passport_document !== imm.passport_document) fd.append('passport_document', formData.passport_document);
            if (formData.proof_of_work_authorization !== imm.proof_of_work_authorization) fd.append('proof_of_work_authorization', formData.proof_of_work_authorization);

            const emg = refetchedData.emergency_contact || {};
            appendIfChanged('emergency_first_name', formData.first_name1, emg.first_name);
            appendIfChanged('emergency_last_name', formData.last_name1, emg.last_name);
            appendIfChanged('emergency_phone_number', formData.phone_number1, emg.phone_number);
            appendIfChanged('relation_type', formData.relation_type, emg.relation_type);

            const ref = refetchedData.referral_info || {};
            appendIfChanged('referrer_name', formData.referrer_name, ref.referrer_name);
            appendIfChanged('referral_phone_number', formData.referral_phone_number, ref.referral_phone_number);
            appendIfChanged('referrer_relationship', formData.referrer_relationship, ref.referrer_relationship);

            // Remove empty / null values (except marketing_risk_level)
            for (const key of Array.from(fd.keys())) {
                if (key === 'marketing_risk_level') continue;
                const val = fd.get(key);
                if (val === null || val === '' || val === 'null') fd.delete(key);
            }

            if (opendataUsc) {
                fd.delete('i94_copy');
                fd.delete('laws_and_regulations');
            } else {
                fd.delete('passport_document');
            }

            const response = await apiService.postRequest('/auth/user/history/update', fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response && response.success === true) {
                setErrors({});
                setErrorMessage('');
                setEditMode(false);
                fetchUserHistory();
            } else {
                setErrorMessage(response.message || '');
                setErrors(response.errors || {});
                if (response && response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('handleSubmit error:', error);
        } finally {
            setSubmitloader(false);
        }
    };

    // ─── Render ───────────────────────────────────────────────────────────────
    const isReferralUnchanged =
    reSaveData.referrer_name === formData2.referrer_name &&
    reSaveData.referral_phone_number === formData2.referral_phone_number &&
    reSaveData.referrer_relationship === formData2.referrer_relationship;
    return (
        <Grid size={{ xs: 12 }} container justifyContent="center" className="registerdetailsmain">
            <RegistrationLogout />
            <Grid size={{ lg: 10, xs: 11 }} container alignItems="flex-start" justifyContent="center" className="regisdetailwhite">
                <Grid size={{ xs: 12 }} container>
                    {generalData && generalData.site_logo ? (
                        <img onClick={() => navigate('/')} src={generalData.site_logo} alt="site logo" />
                    ) : (
                        <img onClick={() => navigate('/')} src={require('../../assets/logo.svg').default} alt="logo" />
                    )}

                    {/* Progress bar */}
                    <Grid size={{ lg: 12, xs: 12 }} container justifyContent="center">
                        <Grid size={{ lg: 6, md: 6, sm: 8, xs: 12 }} container alignItems="center" justifyContent="space-between" className="progressspan">
                            <span className="activeprogress">1</span>
                            <span className="activeprogress">2</span>
                            <span className="activeprogress">3</span>
                            <span className="activeprogress">4</span>
                        </Grid>
                    </Grid>

                    {loading ? (
                        <div className="d-flex justify-content-center w-100">
                            <img style={{ width: '100px' }} src={require('../../assets/pinkloader.gif')} alt="Loading..." />
                        </div>
                    ) : (
                        <form className="w-100" autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                            <Grid size={{ lg: 12, xs: 12 }} container justifyContent="space-between" className="regiter_inputs">
                                <h5>Referral information</h5>

                                {/* Referrer Phone */}
                                <Grid size={{ sm: 5.8, xs: 12 }} container flexDirection="column">
                                    <span>Referrer Phone Number<small className="red_starimpo">*</small></span>
                                    <PhoneInput
                                        className="phone_input_imgs"
                                        placeholder="Enter phone number"
                                        defaultCountry="US"
                                        countries={allowedCountries}
                                        international={false}
                                        limitMaxLength={true}
                                        value={formData2.referral_phone_number}
                                        onChange={handlePhoneChangeStep4}
                                        onKeyDown={handleKeyDownStep4}
                                        autoComplete="new-password"
                                    />
                                    {errors2.referral_phone_number && (
                                        <p style={{ color: 'red' }}>{errors2.referral_phone_number}</p>
                                    )}
                                </Grid>

                                {/* Referrer Name */}
                                <Grid size={{ sm: 5.8, xs: 12 }} container flexDirection="column">
                                    <span>Referrer Name<small className="red_starimpo">*</small></span>
                                    <input
                                        type="text"
                                        maxLength="201"
                                        name="referrer_name"
                                        value={formData2.referrer_name}
                                        onChange={handleInputChange2}
                                        onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                                    />
                                    {errors2.referrer_name && (
                                        <p style={{ color: 'red' }}>{errors2.referrer_name}</p>
                                    )}
                                </Grid>

                                {/* Referrer Relationship */}
                                <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column">
                                    <span>How do you know the referrer?<small className="red_starimpo">*</small></span>
                                    <select
                                        name="referrer_relationship"
                                        value={formData2.referrer_relationship}
                                        onChange={handleInputChange2}
                                    >
                                        <option value="" disabled>Select Referrer</option>
                                        {referrers.map((referrer) => (
                                            <option key={referrer.id} value={referrer.value}>
                                                {referrer.value}
                                            </option>
                                        ))}
                                    </select>
                                    {errors2.referrer_relationship && (
                                        <p style={{ color: 'red' }}>{errors2.referrer_relationship}</p>
                                    )}
                                </Grid>

                                {errorMessage2 && <p style={{ color: 'red' }}>{errorMessage2}</p>}

                                <Grid size={{ sm: 12, xs: 12 }} container justifyContent="space-between" className="mt-5">
                                    <button
                                        className="registersendbtn1"
                                        type="button"
                                        onClick={() => navigate('/registration/emergency-contact', { state: { fromNextPage: true } })}
                                    >
                                        Previous
                                    </button>
                                    {isReferralUnchanged ?
                                        <button className="registersendbtn2" type="button" onClick={()=>setShowPreview(true)}>
                                            Save
                                        </button>:
                                        <button className="registersendbtn2" type="button" onClick={handleSubmitStep4}>
                                            {submitloader2 ? (
                                                <img src={require('../../assets/whiteloader.gif')} alt="Loading..." />
                                            ) : (
                                                'Save'
                                            )}
                                        </button> 
                                    }
                                </Grid>
                            </Grid>
                        </form>
                    )}

                    {/* ── Success Modal ── */}
                    <Modal
                        show={show}
                        onHide={handleClose}
                        size="md"
                        aria-labelledby="success-modal-title"
                        centered
                    >
                        <Modal.Header closeButton style={{ border: 'none' }} />
                        <Modal.Body>
                            <div className="d-flex w-100 text-center flex-column align-items-center modal_register">
                                <FontAwesomeIcon className="main_tickiconpopup" icon={faCircleCheck} />
                                <h3>Congratulation!</h3>
                                <small>
                                    You have successfully submitted your application and it is currently under review.
                                    A recruiter will be in contact with you if you are chosen to move to the next step in process.
                                </small>
                                <button onClick={() => navigate('*')}>Go to Dashboard</button>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* ── Preview Modal ── */}
                    <Modal
                        show={showPreview}
                        onHide={handleClosePreview}
                        size="xl"
                        aria-labelledby="preview-modal-title"
                        centered
                    >
                        <Modal.Header closeButton style={{ border: 'none' }}>
                            <h5 className="mb-0 fw-bold" style={{ color: '#1A5298' }}>Preview</h5>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="d-flex w-100 flex-column align-items-center px-3">

                                {/* ── Read-only profile summary ── */}
                                {!editMode ?
                                <Grid size={{ xs: 12 }} container justifyContent="space-between" className="jobseekers_profilealls">

                                    {/* Personal Information */}
                                    <Grid size={{ xs: 12 }} container><h4 className="mt-0">Personal Information</h4></Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>First Name</span><p>{profiles.first_name}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Last Name</span><p>{profiles.last_name}</p>
                                    </Grid>
                                    <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Email Id</span><p>{profiles.email}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Date of Birth</span><p>{profiles.dob}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Gender</span><p className="capssets">{profiles.gender}</p>
                                    </Grid>
                                    <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Address</span><p className="capssets">{profiles.address}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>City</span><p className="capssets">{profiles.city}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>State</span><p className="capssets">{profiles.state}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Zip Code</span><p>{profiles.zipcode}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Phone Number</span><p>{profiles.phone_number}</p>
                                    </Grid>
                                    <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Why do you want to enroll with us?</span>
                                        <p className="capssets">{profiles.why_enroll}</p>
                                    </Grid>

                                    {/* Immigration Information */}
                                    {profiles.immigration_data && Object.keys(profiles.immigration_data).length > 0 && (
                                        <>
                                            <Grid size={{ xs: 12 }} container><h4>Immigration Information</h4></Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Citizenship Status</span>
                                                <p className="capssets">{profiles.immigration_data?.citizenship_status}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Are you waiting for your EAD Card to Arrive?</span>
                                                <p className="capssets">{profiles.immigration_data?.awaiting_ead_card || 'No data'}</p>
                                            </Grid>
                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>When did you apply for your EAD Card?</span>
                                                <p className="capssets">{profiles.immigration_data?.ead_card_applied_date || 'No data'}</p>
                                            </Grid>
                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Explain your citizenship status</span>
                                                <p className="capssets">{profiles.immigration_data?.citizenship_explanation}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Are you legally authorized to work in United States?</span>
                                                <p className="capssets">{profiles.immigration_data?.legally_authorized_to_work}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>When will your work authorization expire?</span>
                                                <p className="capssets">{profiles.immigration_data?.work_authorization_expiry || 'No data'}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Which year was your SSN Issued?</span>
                                                <p className="capssets">{profiles.immigration_data?.ssn_issue_year || 'No data'}</p>
                                            </Grid>
                                            {opendataUsc && (
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Upload Most Recent Passport Copy</span>
                                                {profiles.immigration_data?.passport_document ? (
                                                    <a href={profiles.immigration_data.passport_document} target="_blank" rel="noopener noreferrer">View</a>
                                                ) : 'No data'}
                                            </Grid>)}
                                            {!opendataUsc && (
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Upload Most Recent I94 Copy</span>
                                                {profiles.immigration_data?.i94_copy ? (
                                                    <a href={profiles.immigration_data.i94_copy} target="_blank" rel="noopener noreferrer">View</a>
                                                ) : 'No data'}
                                            </Grid>)}
                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>
                                                    I hereby authorize agents of TekPossible Consulting to access and verify the
                                                    authenticity of my uploaded I-94 document through the official I-94 website
                                                    (https://i94.cbp.dhs.gov/I94). I understand that this verification will be
                                                    conducted in accordance with applicable laws and regulations.
                                                </span>
                                                <p>Yes</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Upload Proof of Work Authorization</span>
                                                {profiles.immigration_data?.proof_of_work_authorization ? (
                                                    <a href={profiles.immigration_data.proof_of_work_authorization} target="_blank" rel="noopener noreferrer">View</a>
                                                ) : ' No data'}
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Upload Profile Picture</span>
                                                {profiles.profile ? (
                                                    <a href={profiles.profile} target="_blank" rel="noopener noreferrer">View</a>
                                                ) : ' No data'}
                                            </Grid>
                                        </>
                                    )}

                                    {/* Emergency Contact */}
                                    {profiles.emergency_contact && Object.keys(profiles.emergency_contact).length > 0 && (
                                        <>
                                            <Grid size={{ sm: 12, xs: 12 }} container><h4>Emergency Contact</h4></Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>First Name</span><p className="capssets">{profiles.emergency_contact?.first_name}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Last Name</span><p className="capssets">{profiles.emergency_contact?.last_name}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Phone Number</span><p className="capssets">{profiles.emergency_contact?.phone_number}</p>
                                            </Grid>
                                            <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                                <span>Relationship</span><p className="capssets">{profiles.emergency_contact?.relation_type}</p>
                                            </Grid>
                                        </>
                                    )}

                                    {/* Referral Information (read-only) */}
                                    <Grid size={{ sm: 12, xs: 12 }} container><h4>Referral Information</h4></Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Referrer Phone Number</span>
                                        <p className="capssets">{formData.referral_phone_number}</p>
                                    </Grid>
                                    <Grid size={{ sm: 6, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>Referrer Name</span>
                                        <p className="capssets">{formData.referrer_name}</p>
                                    </Grid>
                                    <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" className="seekprof_borders">
                                        <span>How do you know the referrer?</span>
                                        <p className="capssets">{formData.referrer_relationship}</p>
                                    </Grid>
                                </Grid>:
                                <Grid size={{ xs: 12 }} container>
                                    <form className="w-100">
                                        <Grid size={{ lg: 12, xs: 12 }} container justifyContent="space-between" className="regiter_inputs">

                                            <h5>Basic Informations</h5>

                                            {/* First Name */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>First Name<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="first_name"
                                                    value={formData.first_name}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                                                />
                                                {errors.first_name && <p style={{ color: 'red' }}>{errors.first_name}</p>}
                                            </Grid>

                                            {/* Last Name */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Last Name<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="last_name"
                                                    value={formData.last_name}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                                                />
                                                {errors.last_name && <p style={{ color: 'red' }}>{errors.last_name}</p>}
                                            </Grid>

                                            {/* Email (disabled) */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Email<small className="red_starimpo">*</small></span>
                                                <input value={formData.email} disabled readOnly />
                                            </Grid>

                                            {/* DOB */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Date of Birth<small className="red_starimpo">*</small></span>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        className="date_pickermux"
                                                        value={value}
                                                        onChange={handleDateChange}
                                                        maxDate={dayjs().subtract(18, 'year').subtract(1, 'day')}
                                                    />
                                                </LocalizationProvider>
                                                {errors.dob && <p style={{ color: 'red' }}>{errors.dob}</p>}
                                            </Grid>

                                            {/* Gender */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Gender<small className="red_starimpo">*</small></span>
                                                <select name="gender" value={formData.gender} onChange={handleInputChange}>
                                                    <option value="">Select Gender</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="prefer_not_to_answer">Prefer not to answer</option>
                                                </select>
                                                {errors.gender && <p style={{ color: 'red' }}>{errors.gender}</p>}
                                            </Grid>

                                            {/* Address */}
                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column">
                                                <span>Address<small className="red_starimpo">*</small></span>
                                                <input type="text" name="address" value={formData.address} onChange={handleInputChange} />
                                                {errors.address && <p style={{ color: 'red' }}>{errors.address}</p>}
                                            </Grid>

                                            {/* State */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>State<small className="red_starimpo">*</small></span>
                                                <Select
                                                    className="basic-single select_withsearch"
                                                    classNamePrefix="select"
                                                    name="state"
                                                    value={selectedState}
                                                    options={states.map((s) => ({ label: s.name, value: s.state_code }))}
                                                    onChange={handleStateChange}
                                                />
                                                {errors.state && <p style={{ color: 'red' }}>{errors.state}</p>}
                                            </Grid>

                                            {/* City */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>City<small className="red_starimpo">*</small></span>
                                                <Select
                                                    className="basic-single select_withsearch"
                                                    classNamePrefix="select"
                                                    value={selectedCity}
                                                    name="city"
                                                    options={cities.map((c) => ({ label: c.city_name, value: c.city_name }))}
                                                    onChange={handleCityChange}
                                                />
                                                {errors.city && <p style={{ color: 'red' }}>{errors.city}</p>}
                                            </Grid>

                                            {/* Zipcode */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Zip Code<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="zipcode"
                                                    value={formData.zipcode}
                                                    minLength="5"
                                                    maxLength="9"
                                                    onChange={handleInputChange}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ''))}
                                                />
                                                {errors.zipcode && <p style={{ color: 'red' }}>{errors.zipcode}</p>}
                                            </Grid>

                                            {/* Phone Number */}
                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Phone Number<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="phone_number"
                                                    value={formData.phone_number}
                                                    onChange={handlePhoneNumberChange}
                                                    placeholder="(___) ___-____"
                                                    maxLength="14"
                                                    className={errors.phone_number ? 'input-error' : ''}
                                                />
                                                {errors.phone_number && <p style={{ color: 'red' }}>{errors.phone_number}</p>}
                                            </Grid>

                                            {/* ── Immigration ── */}
                                            <h5>Immigration Questions</h5>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Citizenship Status<small className="red_starimpo">*</small></span>
                                                <select name="citizenship_status" value={formData.citizenship_status} onChange={handleInputChange}>
                                                    <option value="" disabled>Select Citizenship Status</option>
                                                    {citizenshipStatuses.map((status) => (
                                                        <option key={status.id} value={status.status}>{status.status}</option>
                                                    ))}
                                                </select>
                                                {errors.citizenship_status && <p style={{ color: 'red' }}>{errors.citizenship_status}</p>}
                                            </Grid>

                                            {opendata && (
                                                <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                    <span>Are you waiting for your EAD Card to Arrive?<small className="red_starimpo">*</small></span>
                                                    <select name="awaiting_ead_card" value={formData.awaiting_ead_card} onChange={handleInputChange}>
                                                        <option value="" disabled>Select</option>
                                                        <option value="yes">Yes</option>
                                                        <option value="no">No</option>
                                                    </select>
                                                    {errors.awaiting_ead_card && <p style={{ color: 'red' }}>{errors.awaiting_ead_card}</p>}
                                                </Grid>
                                            )}

                                            {opendata2 && (
                                                <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                    <span>When did you apply for your EAD Card?<small className="red_starimpo">*</small></span>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            className="date_pickermux"
                                                            value={value2}
                                                            onChange={handleDateChange1}
                                                            maxDate={dayjs(maxDate)}
                                                        />
                                                    </LocalizationProvider>
                                                    {errors.ead_card_applied_date && <p style={{ color: 'red' }}>{errors.ead_card_applied_date}</p>}
                                                </Grid>
                                            )}

                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column">
                                                <span>Explain your citizenship status<small className="red_starimpo">*</small></span>
                                                <textarea
                                                    placeholder="Describe"
                                                    rows="10"
                                                    name="citizenship_explanation"
                                                    value={formData.citizenship_explanation}
                                                    onChange={handleInputChange}
                                                />
                                                {errors.citizenship_explanation && <p style={{ color: 'red' }}>{errors.citizenship_explanation}</p>}
                                            </Grid>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Are you legally authorized to work in United States?<small className="red_starimpo">*</small></span>
                                                <select name="legally_authorized_to_work" value={formData.legally_authorized_to_work} onChange={handleInputChange}>
                                                    <option value="" disabled>Select</option>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </select>
                                                {errors.legally_authorized_to_work && <p style={{ color: 'red' }}>{errors.legally_authorized_to_work}</p>}
                                            </Grid>

                                            {opendata3 && (
                                                <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                    <span>When will your work authorization expire?<small className="red_starimpo">*</small></span>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            className="date_pickermux"
                                                            value={value1}
                                                            onChange={handleDateChange2}
                                                            minDate={dayjs(maxDate)}
                                                        />
                                                    </LocalizationProvider>
                                                    {errors.work_authorization_expiry && <p style={{ color: 'red' }}>{errors.work_authorization_expiry}</p>}
                                                </Grid>
                                            )}

                                            {opendata4 && (
                                                <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column">
                                                    <span>What actions have you taken or are planning to take to renew your Work Authorization?<small className="red_starimpo">*</small></span>
                                                    <textarea
                                                        placeholder="Describe"
                                                        rows="10"
                                                        name="renew_authorization_work"
                                                        value={formData.renew_authorization_work}
                                                        onChange={handleInputChange}
                                                    />
                                                    {errors.renew_authorization_work && <p style={{ color: 'red' }}>{errors.renew_authorization_work}</p>}
                                                </Grid>
                                            )}

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Which year was your SSN Issued?<small className="red_starimpo">*</small></span>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        className="date_pickermux"
                                                        views={['year']}
                                                        maxDate={dayjs(maxDate)}
                                                        value={value3}
                                                        onChange={handleDateChange3}
                                                    />
                                                </LocalizationProvider>
                                                {errors.ssn_issue_year && <p style={{ color: 'red' }}>{errors.ssn_issue_year}</p>}
                                            </Grid>

                                            {opendataUsc && (
                                                <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                    <span>
                                                        Upload Most Recent Passport Copy<br />
                                                        <small>(Upload only .jpg, .jpeg, .png, .pdf, .doc, .docx and with Maximum size as 5MB)</small>
                                                        <small className="red_starimpo">*</small>
                                                    </span>
                                                    <div className="fileUploadInput">
                                                        <input
                                                            type="file"
                                                            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                                                            name="passport_document"
                                                            id="passport_document"
                                                            onChange={handleFileChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label htmlFor="passport_document" style={{ cursor: 'pointer' }}>Upload</label>
                                                        <input type="text" value={fileNames.passport_document || ''} readOnly placeholder="No file chosen" />
                                                    </div>
                                                    {errors.passport_document && <p style={{ color: 'red' }}>{errors.passport_document}</p>}
                                                </Grid>
                                            )}

                                            {!opendataUsc && (
                                                <>
                                                    <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                        <span>Upload Most Recent I94 Copy<small className="red_starimpo">*</small></span>
                                                        <div className="fileUploadInput">
                                                            <input
                                                                type="file"
                                                                name="i94_copy"
                                                                id="i94_copy"
                                                                onChange={handleFileChange}
                                                                style={{ display: 'none' }}
                                                            />
                                                            <label htmlFor="i94_copy" style={{ cursor: 'pointer' }}>Upload</label>
                                                            <input type="text" value={fileNames.i94_copy || ''} readOnly placeholder="No file chosen" />
                                                        </div>
                                                        {errors.i94_copy && <p style={{ color: 'red' }}>{errors.i94_copy}</p>}
                                                    </Grid>
                                                    <Grid size={{ sm: 12 }} container className="my-3" flexDirection="column">
                                                        <span>
                                                            I hereby authorize agents of TekPossible Consulting to access and verify the
                                                            authenticity of my uploaded I-94 document through the official I-94 website (
                                                            <a href="https://i94.cbp.dhs.gov/I94" target="_blank" rel="noopener noreferrer">
                                                                https://i94.cbp.dhs.gov/I94
                                                            </a>
                                                            ). I understand that this verification will be conducted in accordance with applicable
                                                            laws and regulations.<small className="red_starimpo">*</small>
                                                        </span>
                                                        <div className="d-flex align-items-center main_radioregister">
                                                            <input
                                                                type="checkbox"
                                                                name="laws_and_regulations"
                                                                checked={!!formData.laws_and_regulations}
                                                                onChange={handleInputChange}
                                                            />
                                                            I agree
                                                        </div>
                                                        {errors.laws_and_regulations && <p style={{ color: 'red' }}>{errors.laws_and_regulations}</p>}
                                                    </Grid>
                                                </>
                                            )}

                                            {!opendata2 && (
                                                <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                    <span>Upload Proof of Work Authorization<small className="red_starimpo">*</small></span>
                                                    <div className="fileUploadInput">
                                                        <input
                                                            type="file"
                                                            id="proof_of_work_authorization"
                                                            name="proof_of_work_authorization"
                                                            onChange={handleFileChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label htmlFor="proof_of_work_authorization" style={{ cursor: 'pointer' }}>Upload</label>
                                                        <input type="text" value={fileNames.proof_of_work_authorization || ''} readOnly placeholder="No file chosen" />
                                                    </div>
                                                    {errors.proof_of_work_authorization && <p style={{ color: 'red' }}>{errors.proof_of_work_authorization}</p>}
                                                </Grid>
                                            )}

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Upload Profile Picture</span>
                                                <div className="fileUploadInput">
                                                    <input
                                                        type="file"
                                                        id="profile"
                                                        name="profile"
                                                        accept="image/png,image/gif,image/jpeg"
                                                        onChange={handleFileChange}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <label htmlFor="profile" style={{ cursor: 'pointer' }}>Upload</label>
                                                    <input type="text" value={fileNames.profile || ''} readOnly placeholder="No file chosen" />
                                                </div>
                                            </Grid>

                                            {/* ── Emergency Contact ── */}
                                            <h5>Emergency Contact</h5>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>First Name<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="first_name1"
                                                    value={formData.first_name1}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                                                />
                                                {errors.first_name1 && <p style={{ color: 'red' }}>{errors.first_name1}</p>}
                                            </Grid>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Last Name<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="last_name1"
                                                    value={formData.last_name1}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                                                />
                                                {errors.last_name1 && <p style={{ color: 'red' }}>{errors.last_name1}</p>}
                                            </Grid>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Phone Number<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="phone_number1"
                                                    value={formData.phone_number1}
                                                    onChange={handlePhoneNumberChange1}
                                                    placeholder="(___) ___-____"
                                                    maxLength="14"
                                                    className={errors.phone_number1 ? 'input-error' : ''}
                                                />
                                                {errors.phone_number1 && <p style={{ color: 'red' }}>{errors.phone_number1}</p>}
                                            </Grid>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Relationship<small className="red_starimpo">*</small></span>
                                                <select name="relation_type" value={formData.relation_type} onChange={handleInputChange}>
                                                    <option value="" disabled>Select</option>
                                                    {relationships.map((r) => (
                                                        <option key={r.id} value={r.value}>{r.value}</option>
                                                    ))}
                                                </select>
                                                {errors.relation_type && <p style={{ color: 'red' }}>{errors.relation_type}</p>}
                                            </Grid>

                                            {/* ── Referral (editable copy in preview) ── */}
                                            <h5>Referral information</h5>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Referrer Phone Number<small className="red_starimpo">*</small></span>
                                                <PhoneInput
                                                    className="phone_input_imgs"
                                                    placeholder="Enter phone number"
                                                    defaultCountry="US"
                                                    countries={allowedCountries}
                                                    international={false}
                                                    limitMaxLength={true}
                                                    value={formData.referral_phone_number}
                                                    onChange={handlePhoneChange}
                                                    onKeyDown={handleKeyDown2}
                                                    autoComplete="new-password"
                                                />
                                                {errors.referral_phone_number && <p style={{ color: 'red' }}>{errors.referral_phone_number}</p>}
                                            </Grid>

                                            <Grid size={{ md: 5.5, sm: 5.8, xs: 12 }} container flexDirection="column">
                                                <span>Referrer Name<small className="red_starimpo">*</small></span>
                                                <input
                                                    type="text"
                                                    name="referrer_name"
                                                    value={formData.referrer_name}
                                                    onChange={handleInputChange}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                                                />
                                                {errors.referrer_name && <p style={{ color: 'red' }}>{errors.referrer_name}</p>}
                                            </Grid>

                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column">
                                                <span>How do you know the referrer?<small className="red_starimpo">*</small></span>
                                                <select name="referrer_relationship" value={formData.referrer_relationship} onChange={handleInputChange}>
                                                    <option value="" disabled>Select Referrer</option>
                                                    {referrers.map((referrer) => (
                                                        <option key={referrer.id} value={referrer.value}>{referrer.value}</option>
                                                    ))}
                                                </select>
                                                {errors.referrer_relationship && <p style={{ color: 'red' }}>{errors.referrer_relationship}</p>}
                                            </Grid>

                                            {errorMessage && (
                                                <p style={{ color: 'red', width: '100%', marginTop: '15px' }}>{errorMessage}</p>
                                            )}
                                        </Grid>
                                    </form>
                                </Grid>}

                                {/* ── Modal footer actions ── */}
                                <Grid size={{ xs: 12 }} container justifyContent="flex-end" className="gap-3">
                                    {editMode ? <>
                                    <button type='button' className="registersendbtn1" onClick={()=>{setEditMode(false); fetchUserHistory()}}>
                                        Cancel Edit
                                    </button>
                                    <button type="button" onClick={handleSubmit} className="registersendbtn2">
                                        {submitloader ? (
                                            <img src={require('../../assets/whiteloader.gif')} alt="Loading..." />
                                        ) : (
                                            'Save'
                                        )}
                                    </button></>:<>
                                    <button
                                        className="registersendbtn1"
                                        type="button"
                                        onClick={handleClosePreview}
                                    >
                                        Cancel
                                    </button>
                                    <button type='button' className="registersendbtn1" onClick={()=>setEditMode(true)}>
                                        Edit
                                    </button>
                                    <button className="registersendbtn2" type="button" onClick={handleSubmitConfirm}>
                                        {submitLoader ? (
                                            <img src={require('../../assets/whiteloader.gif')} alt="Loading..." />
                                        ) : (
                                            'Confirm'
                                        )}
                                    </button>
                                    </>}
                                </Grid>
                            </div>
                        </Modal.Body>
                    </Modal>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default RegisterDetail4;